module.exports = __webpack_public_path__ + "img/deskshelf25.08510399.jpg";